import { useBuyerAppConfig, useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';
import { IBidHistoryQueryOptions } from '../types';

const BIDS_HISTORY_KEY = 'bids-history-key';

/**
 * ----------------------------------------------------------------------------\
 * React Query hook for bid item history api management it will call
 * `fetchBidHistory` api give error loading success state with response
 */
export const useBidHistoryQuery = (queryParams: IBidHistoryQueryOptions) => {
  const { isRankOneBidDisplayEnabled } = useBuyerAppConfig().bids;
  const { assetId, count, page } = queryParams;

  const { data, isError, error, isLoading, isPending, isFetching, refetch } =
    useQueryWithUserId({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: [
        BIDS_HISTORY_KEY,
        assetId,
        count,
        page,
        isRankOneBidDisplayEnabled,
      ],
      queryFn: () =>
        BIDS_API.fetchBidHistory(queryParams, isRankOneBidDisplayEnabled),
      staleTime: 0,
      gcTime: 1000 * 60 * 5,
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isLoading,
    isPending,
    refetch,
  };
};
